import { render, staticRenderFns } from "./SelectPromotionSKUDiscount.vue?vue&type=template&id=22b178c0&"
import script from "./SelectPromotionSKUDiscount.vue?vue&type=script&lang=js&"
export * from "./SelectPromotionSKUDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports